module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAOCAYAAAAIar0YAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABnSURBVAiZtYyxDUBAAEXfXa4SQ5hCf7UVLGAMiQ3MQqhuAAYwgFInUYmvcYnovfK95NGHee/D1PLghFIwaRSWD38KuShMFyYBJ2gFs8XiwGSg6vW46sLngwUQGhOOJk4XYUvv/QlwAy63HP65d1XbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/px2.png
// module id = UiyV
// module chunks = 1